// 时间戳
export const getTime = function (date) {
  return Math.round(date.getTime() / 1000).toString()
}

// 时间戳渲染
export const timeToDate = function (time, a = '-', b = ':') {
  // 格式化时间
  const date = new Date(time * 1000)
  // 补零
  const zero = num => {
    return num < 10 ? '0' + num.toString() : num
  }
  
  let ymd = [
    date.getFullYear().toString(),
    zero((date.getMonth() + 1).toString()),
    zero(date.getDate().toString())
  ]

  let hms = [
    zero(date.getHours().toString()),
    zero(date.getMinutes().toString()),
    zero(date.getSeconds().toString())
  ]

  return ymd.join(a) + ' ' + hms.join(b)
}

// Table 自定义渲染工具
// 使用方法：(this.$refs.table, [], []) 
export const tableExcel = function (refs, header, data) {
  return refs.exportCsv({
    columns: header,
    data: data.map(row => {
      // 循环渲染内容
      for(const i in header) {
        if(header[i].excel) {
          row = header[i].excel(row)
        }
      }
      return row
    })
  })
}